<template>
  <div v-if="status == 'waiting'">
    <div class="w-full rounded-lg bg-white  p-6 text-center ">
      <img
        style="width:45px ; height: 45px"
        :src="cdn('images/site_creating.gif')"
        class="loader-icon mb-2 rounded-lg border border-grayCust-900 sm2:mb-0"
      >
      <div>
        <div class="flex items-center justify-center">
          <p class="text-xl font-semibold text-grayCust-1550">
            {{ $t('starting_installation') }}
          </p>
        </div>
        <div class="flex items-center justify-center">
          <p class="text-sm font-medium text-grayCust-1550">
            {{ $t('please_wait_for_start_installation') }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div v-if="status == 'processing'">
    <div class="w-full items-center rounded-lg bg-grayCust-270  p-6">
      <img
        style="width:45px ; height: 45px;margin: auto;margin-bottom: 10px;"
        class="loader-icon mb-2 rounded-lg border border-grayCust-900 sm2:mb-0"
        :src="cdn('images/site_creating.gif')"
      >
      <div class="w-full">
        <div class="mb-2 flex items-center justify-between sm2:mb-0 ">
          <p class="text-sm font-medium text-grayCust-1550">
            {{ heading }}
          </p>
          <span class="si-progress ml-2 text-sm font-semibold">{{ percentage }}%</span>
        </div>
        <div class="mt-0.5 h-1.5 rounded-xl bg-grayCust-250">
          <div
            class="si-progress-bar h-1.5 w-4 rounded-xl"
            :style="{ width: percentage + '%' }"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-if="status == 'failed'">
    <div class="w-full rounded-lg bg-white p-6 text-center">
      <img
        style="width:45px;height: 45px;"
        class="mx-auto mb-3 rounded-lg border border-grayCust-900 p-3"
        :src="cdn('images/failed-icon.svg')"
        alt=""
      >
      <div>
        <div class="flex items-center justify-center">
          <p class="mb-1 text-xl font-semibold text-grayCust-1550">
            {{ $t('installation_failed') }}
          </p>
        </div>
        <div class="flex items-center justify-between">
          <p class="text-sm font-medium text-grayCust-1550">
            Sorry, we are unable to create new sites at the moment, please retry after some time.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    
    name: 'ProgressBar',
    props:{
        percentage: {
            default: 0,
            type: Number,
            required: true
        },
        status: {
            default: '',
            type: String,
            required: true
        },
        heading: {
            default: '',//this.$t('installation_in_progress'),
            type: String,
        },
        subHeading: {
            default: '',
            type: String,
        },
    },
}
</script>

<style scoped>
.loader-icon{
    width:45px; 
    height: 45px;
    margin: 0 auto 10px;
}
</style>